// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");
var rulesCommonJS = require("../../js/rulesCommon.js")

// DASHBOARD
const Condition = (params) => {
  
  useEffect(() => {       
    
    cargarCombosAtributos() 

    if(params.conditionInfo.atributeValue !== ""){ 
      setearValoresCondicion() 
    }

    if( (params.conditionInfo.conditionalOperator === "") && (params.conditionInfo.conditionId === "1") ){
      document.getElementById("selectOperadorCondicional"+params.conditionInfo.conditionId).className += " hidden"
    }

  });

  function añadirOpcionACombo(select,valor,etiqueta){
    var opt = document.createElement('option');
    opt.value = valor;
    opt.innerHTML = etiqueta;
    select.appendChild(opt);
  }

  function borrarOpcionesCombo(select) {
    while (select.options.length > 0) {
        select.remove(0);
    }

}

  function cargarCombosAtributos(){ 

    var bloqueCategoriasAtributosTemp = ""

    if(params.objDatosDashboard.InstallationData.GeneralInfo.MainElectricConnectionSensorsInInstallation === "true"){
      if(Object.keys(params.objDatosDashboard.GeneralData).length > 0){ bloqueCategoriasAtributosTemp += '<option value="GeneralData">Información general</option>' }
      if(Object.keys(params.objDatosDashboard.InstallationData.GeneralInfo).length > 0){ bloqueCategoriasAtributosTemp += '<option value="InstallationData.GeneralInfo">Instalación</option>' }
      if(Object.keys(params.objDatosDashboard.MeteoData).length > 0){ bloqueCategoriasAtributosTemp += '<option value="MeteoData">Meteorología</option>' }
      if(Object.keys(params.objDatosDashboard.FVData).length > 0){ bloqueCategoriasAtributosTemp += '<option value="FVData">Paneles solares</option>' }
      if(Object.keys(params.objDatosDashboard.BatteriesData).length > 0){ bloqueCategoriasAtributosTemp += '<option value="BatteriesData">Baterías</option>' }    
      if(Object.keys(params.objDatosDashboard.GeneratorData).length > 0){ bloqueCategoriasAtributosTemp += '<option value="GeneratorData">Grupo electrógeno</option>' }
      if(params.objDatosDashboard.CarsData.length > 0){ bloqueCategoriasAtributosTemp += '<option value="CarsData">Coche</option>' }
      if(Object.keys(params.objDatosDashboard.SelfConsumptionAndSavingsData).length > 0){ 
        if(params.objDatosDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
          bloqueCategoriasAtributosTemp += '<option value="SelfConsumptionAndSavingsData">Economía</option>' 
        }
      }
      if(params.objDatosDispositivos.length > 0){ bloqueCategoriasAtributosTemp += '<option value="Devices">Dispositivos inteligentes</option>' }
      bloqueCategoriasAtributosTemp += '<option value="Schedule">Planificación horaria</option>'
    }
    else{
      if(Object.keys(params.objDatosDashboard.MeteoData).length > 0){ bloqueCategoriasAtributosTemp += '<option value="MeteoData">Meteorología</option>' }
    }
    
    document.getElementById("selectCategoriaAtributos"+params.conditionInfo.conditionId).innerHTML = bloqueCategoriasAtributosTemp

    if(params.conditionInfo.atribute === ""){ document.getElementById("selectCategoriaAtributos"+params.conditionInfo.conditionId).selectedIndex = 0; }
    else{ document.getElementById("selectCategoriaAtributos"+params.conditionInfo.conditionId).value = params.conditionInfo.atribute.split("|")[0] }

    cargarAtributosCategoria(document.getElementById("selectCategoriaAtributos"+params.conditionInfo.conditionId).value)

    setearUnidadAtributo(params.conditionInfo.conditionId)

  }

  function cargarAtributosCategoria(idGrupoAtributos){

    var blacklistAtributos = ['DashboardTimerRefresh','AppliancesVerified','InstallationType','EnergyGridConnected','CityName','MunicipalityId','QueryUpdateTime','Forecasting',
    'AEMETUpdateTime','ProvinceName','NowForcasting','InstallationLongitude','InstallationLatitude','PowerContracted','FVMaxGeneration','FVType','BatteriesInverterMaxPower',
    'BatteriesMaxCapacity','GeneratorOnOffSwitch','GeneratorMaxGeneration','GeneratorTankCapacity','MaximumChargeAmperage','CarName','UpdateTime','DynamicChargeStatus','TelegramAccount','GeneralGridSwitch',
    'Sunrise','Sunset','ElectricSystemType','MainElectricConnectionSensorsInInstallation','FVMaxGenerationEstimationMode','RemainingBatteryChargeTime','RemainingBatteryDischargeTime',
    'CombustiblePrice','CarID',"CurrentMonthlastUpdate","SinceRegistrationlastUpdate","TodaylastUpdate","YearlastUpdate","GeneratorType","BillDiscount","DailyEnergyBuyPrice","SolarWallet", 'TodayDiscountValue',
    'TodayFixedPayments','TodayTotalReactive','CurrentMonthDiscountValue','CurrentMonthFixedPayments','CurrentMonthTotalReactive','YearDiscountValue','YearFixedPayments','YearTotalReactive',
    'SinceRegistrationDiscountValue','SinceRegistrationFixedPayments','SinceRegistrationTotalReactive','HistoricalMaxPowerConsumption','TodaylastUpdate','CurrentMonthlastUpdate','YearlastUpdate','SinceRegistrationlastUpdate',
    'SolarWalletActivationDate','PowerExcessesLastOcurrence','TotalReactiveEnergy','FVSubsidy','SolarWalletFree','BillingStartDate',"MaxPowerContracted","ChargesInInstallation","Application","RulesConfigured",'PowerConfiguration','EnergyConfiguration',
    'TodayfromGridPerTimeframe','CurrentMonthfromGridPerTimeframe','YearfromGridPerTimeframe','SinceRegistrationfromGridPerTimeframe','BatteryTemperature','LastBillingFeesCheck','BestBuyPrice','WorstBuyPrice','BestSellPrice','WorstSellPrice',
    'DailyAverageBuyPrice','DailyAverageSellPrice','BatteryId','FVId',"DynamicBatteriesNightCharge","TOUPermitsAccepted","CurrentBatteryWorkingMode","DailyAverageSellPriceDaylight"]

    var objDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))

    if( (Object.keys(objDashboard.FVData).length === 0) || (objDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true") ){
      blacklistAtributos.push("FVMaxGenerationEstimation")
    }

    //Instalación básica conectada a la red general
    if( (Object.keys(objDashboard.FVData).length === 0) && (Object.keys(objDashboard.BatteriesData).length === 0) && (Object.keys(objDashboard.GeneratorData).length === 0) ){
      blacklistAtributos.push("TotalBulkGeneration")
      blacklistAtributos.push("TotalWastedEnergy")
      blacklistAtributos.push("GeneralWhInstallationConsumptionP1")
      blacklistAtributos.push("GeneralWhInstallationGenerationP1")
      blacklistAtributos.push("GeneralWhInstallationTOTALGeneration")
      blacklistAtributos.push("GeneralWhInstallationTOTALWastedEnergy")
      blacklistAtributos.push("GeneralWhInstallationWastedEnergyP1")
    }

    if(objDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "false"){
      
      blacklistAtributos.push("GeneralWhInstallationTOTALGeneration")      
      blacklistAtributos.push("GeneralWhInstallationTOTALWastedEnergy")      
      blacklistAtributos.push("MarketAverageBuyPrice")      
      blacklistAtributos.push("PowerContracted")      
      
      blacklistAtributos.push("TodayPowerExcessesCount")           

      blacklistAtributos.push("TodayGivenAwayMoney")      
      blacklistAtributos.push("TodayenergyRevenue")
      blacklistAtributos.push("TodayenergyWaste")              
      blacklistAtributos.push("TodaytoGrid")
      blacklistAtributos.push("TodayfromGrid")
      blacklistAtributos.push("TodayPercentageReactive")
      

      blacklistAtributos.push("CurrentMonthGivenAwayMoney")      
      blacklistAtributos.push("CurrentMonthenergyRevenue")
      blacklistAtributos.push("CurrentMonthenergyWaste")   
      blacklistAtributos.push("CurrentMonthtoGrid")
      blacklistAtributos.push("CurrentMonthfromGrid")
      blacklistAtributos.push("CurrentMonthPercentageReactive")
    
      blacklistAtributos.push("YearenergyRevenue")
      blacklistAtributos.push("YearenergyWaste")   
      blacklistAtributos.push("YeartoGrid")  
      blacklistAtributos.push("YearfromGrid")
      blacklistAtributos.push("YearPercentageReactive")
      
      blacklistAtributos.push("SinceRegistrationenergyRevenue")
      blacklistAtributos.push("SinceRegistrationenergyWaste")   
      blacklistAtributos.push("SinceRegistrationtoGrid")
      blacklistAtributos.push("SinceRegistrationfromGrid")
      blacklistAtributos.push("SinceRegistrationPercentageReactive")

      blacklistAtributos.push("CurrentMonthEnergeticUse")
      blacklistAtributos.push("CurrentMonthPowerExcessesCount")
      blacklistAtributos.push("CurrentMonthPowerExcessesPenalty")
      blacklistAtributos.push("CurrentMonthTotalGeneration")
      blacklistAtributos.push("CurrentMonthconsumption")
      blacklistAtributos.push("CurrentMonthsavingsBalance")
      blacklistAtributos.push("CurrentMonthselfConsumption")
      blacklistAtributos.push("CurrentMonthselfConsumptionBalance")
      blacklistAtributos.push("CurrentMonthusedEnergyCost")
      blacklistAtributos.push("CurrentSolarWalletBalance")
      blacklistAtributos.push("PreviousMonthsSolarWalletBalance")
      blacklistAtributos.push("SinceRegistrationEnergeticUse")
      blacklistAtributos.push("SinceRegistrationPowerExcessesCount")
      blacklistAtributos.push("SinceRegistrationPowerExcessesPenalty")
      blacklistAtributos.push("SinceRegistrationReactivePenaltyAmount")
      blacklistAtributos.push("SinceRegistrationTotalGeneration")
      blacklistAtributos.push("SinceRegistrationsavingsBalance")
      blacklistAtributos.push("SinceRegistrationselfConsumption")
      blacklistAtributos.push("SinceRegistrationselfConsumptionBalance")
      blacklistAtributos.push("SinceRegistrationusedEnergyCost")
      blacklistAtributos.push("TodayEnergeticUse")
      blacklistAtributos.push("TodayPowerExcessesPenalty")
      blacklistAtributos.push("TodayReactivePenaltyAmount")
      blacklistAtributos.push("TodayTotalGeneration")
      blacklistAtributos.push("Todayconsumption")
      blacklistAtributos.push("TodaysavingsBalance")
      blacklistAtributos.push("TodayselfConsumption")
      blacklistAtributos.push("TodayselfConsumptionBalance")
      blacklistAtributos.push("TodayusedEnergyCost")
      blacklistAtributos.push("YearEnergeticUse")
      blacklistAtributos.push("YearPowerExcessesCount")
      blacklistAtributos.push("YearPowerExcessesPenalty")
      blacklistAtributos.push("YearReactivePenaltyAmount")
      blacklistAtributos.push("YearTotalGeneration")
      blacklistAtributos.push("Yearconsumption")
      blacklistAtributos.push("YearsavingsBalance")
      blacklistAtributos.push("YearselfConsumption")
      blacklistAtributos.push("YearselfConsumptionBalance")
      blacklistAtributos.push("YearusedEnergyCost")     
      blacklistAtributos.push("CurrentMonthReactivePenaltyAmount")     
      blacklistAtributos.push("SinceRegistrationconsumption")     


    }
    
    if((Object.keys(objDashboard.FVData).length === 0)){
      blacklistAtributos.push("TodayTotalGeneration")      
      blacklistAtributos.push("TodayselfConsumption")
      blacklistAtributos.push("TodayEnergeticUse")
      blacklistAtributos.push("Todayconsumption")
      blacklistAtributos.push("TodayusedEnergyCost")
      
      blacklistAtributos.push("CurrentMonthTotalGeneration")
      blacklistAtributos.push("CurrentMonthselfConsumption")      
      blacklistAtributos.push("CurrentMonthEnergeticUse")
      blacklistAtributos.push("CurrentMonthconsumption")
      blacklistAtributos.push("CurrentMonthusedEnergyCost")

      blacklistAtributos.push("YearTotalGeneration")
      blacklistAtributos.push("YearselfConsumption")
      blacklistAtributos.push("YearEnergeticUse")
      blacklistAtributos.push("Yearconsumption")
      blacklistAtributos.push("YearusedEnergyCost")

      blacklistAtributos.push("SinceRegistrationTotalGeneration")
      blacklistAtributos.push("SinceRegistrationselfConsumption")
      blacklistAtributos.push("SinceRegistrationEnergeticUse")
      blacklistAtributos.push("SinceRegistrationconsumption")
      blacklistAtributos.push("SinceRegistrationusedEnergyCost")

    }

    if( objDashboard.InstallationData.GeneralInfo.ElectricSystemType === "MONOFASICO" ){
        
      blacklistAtributos.push("GeneralWhInstallationGenerationP1")
      blacklistAtributos.push("GeneralWhInstallationGenerationP2")
      blacklistAtributos.push("GeneralWhInstallationGenerationP3")

      blacklistAtributos.push("GeneralWhInstallationConsumptionP1")
      blacklistAtributos.push("GeneralWhInstallationConsumptionP2")
      blacklistAtributos.push("GeneralWhInstallationConsumptionP3")

      blacklistAtributos.push("GeneralWhInstallationWastedEnergyP1")
      blacklistAtributos.push("GeneralWhInstallationWastedEnergyP2")
      blacklistAtributos.push("GeneralWhInstallationWastedEnergyP3")

      blacklistAtributos.push("GeneralWhInstallationReactiveEnergyP1")
      blacklistAtributos.push("GeneralWhInstallationReactiveEnergyP2")
      blacklistAtributos.push("GeneralWhInstallationReactiveEnergyP3")

      blacklistAtributos.push("GeneralWhInstallationCapacitiveEnergyP1")
      blacklistAtributos.push("GeneralWhInstallationCapacitiveEnergyP2")
      blacklistAtributos.push("GeneralWhInstallationCapacitiveEnergyP3")
      
    }

    if( objDashboard.GeneratorData.GeneratorType === "MONOFASICO" ){
        
      blacklistAtributos.push("GeneralWhGeneratorGenerationP1")
      blacklistAtributos.push("GeneralWhGeneratorGenerationP2")
      blacklistAtributos.push("GeneralWhGeneratorGenerationP3")

    }

    var varObjAtributosTemp = ""
    var comboAtributosTemp = ""

    if(idGrupoAtributos === "Devices"){       
      var ObjAtributosTemp = params.objDatosDispositivos

      var nombreTempDispositivo = ""

      for(var x=0; x < ObjAtributosTemp.length; x++){

        nombreTempDispositivo = ObjAtributosTemp[x].Nombre
        if(ObjAtributosTemp[x].TipoDispositivo === "SENSOR_TEMPERATURA"){ nombreTempDispositivo = "Temperatura " + ObjAtributosTemp[x].Nombre }
        else if(ObjAtributosTemp[x].TipoDispositivo === "SENSOR_HUMEDAD"){ nombreTempDispositivo = "Humedad " + ObjAtributosTemp[x].Nombre }
        else if(ObjAtributosTemp[x].TipoDispositivo === "SENSOR_VOC"){ nombreTempDispositivo = "Partículas orgánicas " + ObjAtributosTemp[x].Nombre }
        else if(ObjAtributosTemp[x].TipoDispositivo === "SENSOR_CH2O"){ nombreTempDispositivo = "Formaldehído " + ObjAtributosTemp[x].Nombre }
        else if(ObjAtributosTemp[x].TipoDispositivo === "SENSOR_CO2"){ nombreTempDispositivo = "CO2 " + ObjAtributosTemp[x].Nombre }

        if(ObjAtributosTemp[x].MarcaDispositivo === "BROADLINK"){
          if ( (ObjAtributosTemp[x].TipoDispositivo !== "SENSOR_TEMPERATURA") && 
               (ObjAtributosTemp[x].TipoDispositivo !== "SENSOR_HUMEDAD") && 
               (ObjAtributosTemp[x].TipoDispositivo !== "TV") &&
               (ObjAtributosTemp[x].TipoDispositivo !== "EQUIPO_SONIDO") &&
               (ObjAtributosTemp[x].TipoDispositivo !== "LUZ*PULSADOR")                   
               ){
            comboAtributosTemp += '<option value="'+ObjAtributosTemp[x].MarcaDispositivo+'|'+ObjAtributosTemp[x].IdDispositivo+'|Estado">Estado de '+nombreTempDispositivo+'</option>'        
          }
          else{
            if (ObjAtributosTemp[x].TipoDispositivo === "SENSOR_TEMPERATURA"){
              comboAtributosTemp += '<option value="'+ObjAtributosTemp[x].MarcaDispositivo+'|'+ObjAtributosTemp[x].IdDispositivo+'|Estado">Estado de '+nombreTempDispositivo.replaceAll("Temperatura ","Dispositivo BROADLINK ")+'</option>'        
            }              
          }
        }
        else if(ObjAtributosTemp[x].TipoDispositivo === "ESCENA"){
          //NO INCLUYO OPCIONES DE ACCIONES EN LA CONDICIÓN YA QUE NO TIENEN VALORES, LAS ESCENAS SÓLO SE PUEDEN EJECUTAR
        }
        else{
          comboAtributosTemp += '<option value="'+ObjAtributosTemp[x].MarcaDispositivo+'|'+ObjAtributosTemp[x].IdDispositivo+'|Estado">Estado de '+nombreTempDispositivo+'</option>'        
        }
        
        if(ObjAtributosTemp[x].Valor !== "N/A"){
          if(ObjAtributosTemp[x].MarcaDispositivo === "BROADLINK"){
            if (ObjAtributosTemp[x].TipoDispositivo !== "AIRE_ACONDICIONADO"){
              comboAtributosTemp += '<option value="'+ObjAtributosTemp[x].MarcaDispositivo+'|'+ObjAtributosTemp[x].IdDispositivo+'|Valor">Valor de '+nombreTempDispositivo+'</option>'
            }              
          }
          else if(ObjAtributosTemp[x].TipoDispositivo === "ESCENA"){
            //NO INCLUYO OPCIONES DE ACCIONES EN LA CONDICIÓN YA QUE NO TIENEN VALORES, LAS ESCENAS SÓLO SE PUEDEN EJECUTAR
          }
          else{
            comboAtributosTemp += '<option value="'+ObjAtributosTemp[x].MarcaDispositivo+'|'+ObjAtributosTemp[x].IdDispositivo+'|Valor">Valor de '+nombreTempDispositivo+'</option>'
          }

        }        
        
      }

    }
    else if(idGrupoAtributos === "Schedule"){
      comboAtributosTemp += '<option value="Hour">'+initialConfigCommonJS.obtenerLiteralAtributo("Hour")+'</option>'
      comboAtributosTemp += '<option value="Minute">'+initialConfigCommonJS.obtenerLiteralAtributo("Minute")+'</option>'
      comboAtributosTemp += '<option value="WeekDay">'+initialConfigCommonJS.obtenerLiteralAtributo("WeekDay")+'</option>'
      comboAtributosTemp += '<option value="Day">'+initialConfigCommonJS.obtenerLiteralAtributo("Day")+'</option>'      
      comboAtributosTemp += '<option value="Month">'+initialConfigCommonJS.obtenerLiteralAtributo("Month")+'</option>'      
    }
    else{
      if(idGrupoAtributos === "GeneralData"){ varObjAtributosTemp = params.objDatosDashboard.GeneralData }
      else if(idGrupoAtributos === "InstallationData.GeneralInfo"){ 
        varObjAtributosTemp = params.objDatosDashboard.InstallationData.GeneralInfo 

        blacklistAtributos.push("BestBuyPrice")      
        blacklistAtributos.push("BestSellPrice")      
        blacklistAtributos.push("MarketAverageBuyPrice")      
        blacklistAtributos.push("WorstBuyPrice")  
        blacklistAtributos.push("WorstSellPrice")  
        blacklistAtributos.push("EnergyBuyPrice")  
        blacklistAtributos.push("DailyAverageBuyPrice")      
        blacklistAtributos.push("DailyAverageSellPrice")
        blacklistAtributos.push("DailyAverageSellPriceDaylight")
      }
      else if(idGrupoAtributos === "MeteoData"){ 
        varObjAtributosTemp = params.objDatosDashboard.MeteoData 
        
        params.objDatosDashboard.MeteoData.SunriseOffset = "0"
        params.objDatosDashboard.MeteoData.SunsetOffset = "0"

        params.objDatosDashboard.MeteoData.ItsDay = "0"
        params.objDatosDashboard.MeteoData.ItsNight = "0"


      }
      else if(idGrupoAtributos === "FVData"){ 
        varObjAtributosTemp = params.objDatosDashboard.FVData 

        blacklistAtributos.push("EnergySellPrice")  
        blacklistAtributos.push("DailyEnergySellPrice")  

      }
      else if(idGrupoAtributos === "BatteriesData"){ varObjAtributosTemp = params.objDatosDashboard.BatteriesData }
      else if(idGrupoAtributos === "GeneratorData"){ varObjAtributosTemp = params.objDatosDashboard.GeneratorData }
      else if(idGrupoAtributos === "CarsData"){ varObjAtributosTemp = params.objDatosDashboard.CarsData[0] }    
      else if(idGrupoAtributos === "SelfConsumptionAndSavingsData"){ 
        
        varObjAtributosTemp = params.objDatosDashboard.SelfConsumptionAndSavingsData         

        if(objDashboard.InstallationData.GeneralInfo.EnergyBuyPrice === ""){
          varObjAtributosTemp["MarketAverageBuyPrice"] = params.objDatosDashboard.InstallationData.GeneralInfo.DailyEnergyBuyPrice.Value                            
        }
        else{
          varObjAtributosTemp["EnergyBuyPrice"] = params.objDatosDashboard.InstallationData.GeneralInfo.EnergyBuyPrice          
        }

        if(objDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "false"){
          blacklistAtributos.push("BestBuyPrice")      
          blacklistAtributos.push("BestSellPrice")      
          blacklistAtributos.push("MarketAverageBuyPrice")      
          blacklistAtributos.push("WorstBuyPrice")  
          blacklistAtributos.push("WorstSellPrice")  
          blacklistAtributos.push("EnergyBuyPrice")  
          blacklistAtributos.push("DailyAverageBuyPrice")      
          blacklistAtributos.push("DailyAverageSellPrice")
          blacklistAtributos.push("DailyAverageSellPriceDaylight")          
        }
        else{
          
          if(Object.keys(objDashboard.FVData).length !== 0){           

            if(params.objDatosDashboard.FVData.EnergySellPrice.Value === ""){ // Indexada
              varObjAtributosTemp["DailyEnergySellPrice"] = params.objDatosDashboard.FVData.DailyEnergySellPrice.Value  
            }
            else{ //Fija
              varObjAtributosTemp["EnergySellPrice"] = params.objDatosDashboard.FVData.EnergySellPrice.Value
            }            
            
          }

        }

      }    

      var arrayKeysAtributos = Object.keys(varObjAtributosTemp).sort()

      for(var y=0; y < arrayKeysAtributos.length; y++){
        if(!blacklistAtributos.includes(arrayKeysAtributos[y])){
          if(varObjAtributosTemp[arrayKeysAtributos[y]].Value !== "N/A"){            
              comboAtributosTemp += '<option value="'+arrayKeysAtributos[y]+'">'+initialConfigCommonJS.obtenerLiteralAtributo(arrayKeysAtributos[y])+'</option>'            
          }           
        }
      }
    }

    document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).innerHTML = comboAtributosTemp

    var valorAtributoTemp = params.conditionInfo.atribute.split("|")

    if(params.conditionInfo.atribute === ""){ 
      document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).selectedIndex = 0; 
    }
    else{ 
      if(idGrupoAtributos === "Devices"){
        document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value = valorAtributoTemp[1]+"|"+valorAtributoTemp[2]+"|"+valorAtributoTemp[3]
      }
      else{
        if(comboAtributosTemp.includes(valorAtributoTemp[1])){
          document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value = valorAtributoTemp[1] 
        }
        else{
          document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).selectedIndex = 0; 
        }
        
      }
      
    }

    if( (document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value.includes("|Estado")) ||
        (valorAtributoTemp[1] === "ChargeLatchStatus") ||
        (valorAtributoTemp[1] === "ChargeStatus") ||
        (valorAtributoTemp[1] === "FVStatus") ||
        (valorAtributoTemp[1] === "BatteryStatus") ||
        (valorAtributoTemp[1] === "ForceSurplusSellToGrid") ||
        (valorAtributoTemp[1] === "ForceBatteryChargeFromGrid") ||
        (valorAtributoTemp[1] === "WeekDay") ||
        (valorAtributoTemp[1] === "Month") ){
      document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "")
    }
    else{      
      document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "")
      document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "") + " hidden"
    }

    setearUnidadAtributo(params.conditionInfo.conditionId)

  }

  function setearValoresCondicion(){

    document.getElementById("selectOperadorCondicional"+params.conditionInfo.conditionId+params.conditionInfo.conditionalOperator).checked = true    
    document.getElementById("selectCategoriaAtributos"+params.conditionInfo.conditionId).value = params.conditionInfo.atribute.split("|")[0] 
    
    if(params.conditionInfo.atribute.split("|")[0] === "Devices"){
      document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value = params.conditionInfo.atribute.split("|")[1]+"|"+params.conditionInfo.atribute.split("|")[2]+"|"+params.conditionInfo.atribute.split("|")[3]

      if(!document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).innerHTML.includes(params.conditionInfo.atribute.split("|")[1]+"|"+params.conditionInfo.atribute.split("|")[2]+"|"+params.conditionInfo.atribute.split("|")[3])){
        initialConfigCommonJS.mostrarMensajeInformativo("Creaste esta regla con una configuración que ha cambiado en tu instalación. Comprueba que todas las aplicaciones de tus dispositivos inteligentes funcionan correctamente y si el problema persiste puedes dirigirte a nosotros en el apartado de 'Ayuda y soporte'.","negative")
      }
    }
    else{
      document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value = params.conditionInfo.atribute.split("|")[1]
    }    
    
    document.getElementById("selectListaComparadores"+params.conditionInfo.conditionId).value = params.conditionInfo.comparator

    if( (params.conditionInfo.atribute.includes("|Estado")) ||
        (params.conditionInfo.atribute.includes("ChargeLatchStatus")) ||
        (params.conditionInfo.atribute.includes("ChargeStatus")) ||
        (params.conditionInfo.atribute.includes("FVStatus")) ||
        (params.conditionInfo.atribute.includes("BatteryStatus")) ||
        (params.conditionInfo.atribute.includes("WeekDay")) ||
        (params.conditionInfo.atribute.includes("Month")) ||        
        (params.conditionInfo.atribute.includes("ForceSurplusSellToGrid")) ||
        (params.conditionInfo.atribute.includes("ForceBatteryChargeFromGrid")) ) {
          
      document.getElementById("selectEstadoDispositivo"+params.conditionInfo.conditionId).value = params.conditionInfo.atributeValue
    }

    document.getElementById("valorAtributo"+params.conditionInfo.conditionId).value = params.conditionInfo.atributeValue    

  }

  function setearUnidadAtributo(idCondicion){

    try{
      var idCategoria = document.getElementById("selectCategoriaAtributos"+idCondicion).value    
      var idAtributo = document.getElementById("selectListaAtributos"+idCondicion).value
          
      document.getElementById("valorAtributo"+idCondicion).value = ""
      document.getElementById("valorAtributo"+idCondicion).setAttribute("inputMode", "decimal")        

      var unidad = ""

      if(idCategoria === "Devices"){

        document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "")

        var idDispositivoActual = idAtributo.split("|")[1]
        var tipoAtributoActual = idAtributo.split("|")[2]
        var idDispositivoTemp = ""
        var tipoDispositivo = ""
        var estadoDispositivoTemp = ""
        var valorDispositivoTemp = ""
        var marcaDispositivoTemp = ""
        unidad = ""

        for(var x=0; x < params.objDatosDispositivos.length; x++){

          idDispositivoTemp = params.objDatosDispositivos[x]["IdDispositivo"]
          estadoDispositivoTemp = params.objDatosDispositivos[x]["Estado"]        
          valorDispositivoTemp = params.objDatosDispositivos[x]["Valor"]        
          marcaDispositivoTemp = params.objDatosDispositivos[x]["MarcaDispositivo"]        

          if(idDispositivoActual === idDispositivoTemp){

            tipoDispositivo = dashboardCommonJS.obtenerTipoDispositivo(idDispositivoTemp, idCategoria)

            if(tipoAtributoActual === "Estado"){
              document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "") 
              document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
              
              borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
              
              if(tipoDispositivo === "PERSIANA"){

                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Subida")
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"off","Bajada")    
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")    

                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Subida" }
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Bajada" }
                else{ estadoDispositivoTemp = "Offline" }

              }
              else if( (tipoDispositivo === "SENSOR_TEMPERATURA") || (tipoDispositivo === "SENSOR_HUMEDAD") ){

                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Con conexión")              
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")   
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Online" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Online" }
                else{ estadoDispositivoTemp = "Offline" }

              
              }
              else if(tipoDispositivo === "SENSOR_PUERTA_VENTANA"){

                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Abierto")              
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"off","Cerrado")   
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")   
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Abierto" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Cerrado" }
                else{ estadoDispositivoTemp = "Offline" }

              
              }
              else if(tipoDispositivo === "TV"){
                
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Con conexión")              
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")   
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Online" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Online" }
                else{ estadoDispositivoTemp = "Offline" }

              }
              else if(tipoDispositivo.includes("LAVADORA")){
                
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Lista para lavar")              
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"off","Control remoto desactivado")              
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"running","Lavando")              
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")   
                
                if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "LavadoraLista" }              
                else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "LavadoraRemotoDesactivado" }
                else if(estadoDispositivoTemp === "running"){ estadoDispositivoTemp = "LavadoraLavando" }
                else{ estadoDispositivoTemp = "Offline" }

              }
              else if(marcaDispositivoTemp === "BROADLINK"){

                if(tipoDispositivo === "AIRE_ACONDICIONADO"){
                  añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"CALOR","Encendido Modo CALOR")              
                  añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"FRIO","Encendido Modo FRIO")   
                  añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"off","Apagado")   
                  
                  if(estadoDispositivoTemp === "CALOR"){ estadoDispositivoTemp = "CALOR" }              
                  else if(estadoDispositivoTemp === "FRIO"){ estadoDispositivoTemp = "FRIO" }
                  else{ estadoDispositivoTemp = "off" }
                }
                else{
                  añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Con conexión")              
                  añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")   
                  
                  if(estadoDispositivoTemp === "on"){ estadoDispositivoTemp = "Online" }              
                  else if(estadoDispositivoTemp === "off"){ estadoDispositivoTemp = "Online" }
                  else{ estadoDispositivoTemp = "Offline" }
                }

              }
              else{

                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"on","Encendido")
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"off","Apagado")    
                añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Sin conexión")    

              }

              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = dashboardCommonJS.obtenerLiteralEstadoAccion(estadoDispositivoTemp)       

            }
            else{ // Valor

              if(valorDispositivoTemp !== "N/A"){
                document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "")  
                document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")

                unidad = ""

                if(tipoDispositivo === "SENSOR_TEMPERATURA"){ unidad = "°C" }
                else if( (tipoDispositivo === "SENSOR_HUMEDAD") || (tipoDispositivo === "SENSOR_PUERTA_VENTANA") ){ unidad = "%" }
                else if(tipoDispositivo === "SENSOR_VOC"){ unidad = "ppm" }
                else if(tipoDispositivo === "SENSOR_CH2O"){ unidad = "mg/m³" }
                else if(tipoDispositivo === "SENSOR_CO2"){ unidad = "ppm" }
                else if( (tipoDispositivo === "AIRE_ACONDICIONADO") || (tipoDispositivo === "AIRE_ACONDICIONADO*DIRECTO") || (tipoDispositivo === "TERMO") ){ unidad = "°C" }
                else if(tipoDispositivo === "MONITOR_CONSUMO"){ unidad = "W" }
                else if(tipoDispositivo === "MONITOR_CONSUMO_INTERRUPTOR"){ unidad = "W" }              
                else if(tipoDispositivo === "ENCHUFE"){ unidad = "W" }                            
                else if( (tipoDispositivo === "PERSIANA") && (marcaDispositivoTemp === "SHELLY") ){ unidad = "%" }                            
                
                document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", unidad)  
                document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(valorDispositivoTemp) + " " + unidad
              }
              else{
                document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"
              }          
            }
            break
          }
        }      

      }
      else{

        if(idCategoria.includes("InstallationData.GeneralInfo")){

          if((idAtributo==="EnergyBuyPrice") || (idAtributo==="MarketAverageBuyPrice")){
            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "€")  
            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo]).toFixed(6))+" €"
          }
          else{
            try{
              document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo].Unit)  
              document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")          
              
              if( params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo].Unit.includes("€") ){
                document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo].Value)+" "+params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo].Unit
              }
              else{                
                document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo].Value+" "+params.objDatosDashboard["InstallationData"]["GeneralInfo"][idAtributo].Unit
              }

            }
            catch(error){console.log(error)}
          }
        }
        else if(idCategoria.includes("FVData")){
          
          unidad = params.objDatosDashboard[idCategoria][idAtributo].Unit

          if(idAtributo === "FVStatus"){
            borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Online","Online")                  
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Offline","Offline")

            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][idAtributo]
          }
          else if(idAtributo === "ForceSurplusSellToGrid"){
            borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"true","Activado")
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"false","Desactivado")                     

            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")

            if(params.objDatosDashboard[idCategoria][idAtributo] === "true"){
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = "Activado"
            }
            else{
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = "Desactivado"
            }            

          }
          else{

            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", params.objDatosDashboard[idCategoria][idAtributo].Unit)  
            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")

            if(unidad.includes("€")){
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(params.objDatosDashboard[idCategoria][idAtributo].Value).toFixed(2))+" "+unidad
            }
            else{            
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][idAtributo].Value+" "+params.objDatosDashboard[idCategoria][idAtributo].Unit
            }
            
          }

          

        }
        else if(idCategoria.includes("BatteriesData")){

          if(idAtributo === "BatteryStatus"){
            borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Cargando","Cargando")
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Descargando","Descargando")          
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Cargada","Cargada")        
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"N/A","En reposo")
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Desconectada","Desconectada")    

            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][idAtributo]

          }
          else if(idAtributo === "ForceBatteryChargeFromGrid"){
            borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"true","Activado")
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"false","Desactivado")                     

            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")

            if(params.objDatosDashboard[idCategoria][idAtributo] === "true"){
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = "Activado"
            }
            else{
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = "Desactivado"
            }            

          }
          else{
            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", params.objDatosDashboard[idCategoria][idAtributo].Unit)  
            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            if( params.objDatosDashboard[idCategoria][idAtributo].Unit.includes("€") || 
                params.objDatosDashboard[idCategoria][idAtributo].Unit.includes("A") || 
                params.objDatosDashboard[idCategoria][idAtributo].Unit.includes("V") ){
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(params.objDatosDashboard[idCategoria][idAtributo].Value)+" "+params.objDatosDashboard[idCategoria][idAtributo].Unit
            }
            else{
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][idAtributo].Value+" "+params.objDatosDashboard[idCategoria][idAtributo].Unit
            }
          }

          

        }
        else if(idCategoria.includes("CarsData")){
          //Actualmente sólo compatible con 1 coche por instalación, de ahí el [0]
          if(params.objDatosDashboard[idCategoria][0][idAtributo].Unit !== undefined){
            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", params.objDatosDashboard[idCategoria][0][idAtributo].Unit)  
            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][0][idAtributo].Value+" "+params.objDatosDashboard[idCategoria][0][idAtributo].Unit
          }
          else{         

            if(idAtributo === "ChargeLatchStatus"){
              borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Conectado","Conectado")
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Desconectado","Desconectado")
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Bloqueado","Bloqueado")  
            }

            else if(idAtributo === "ChargeStatus"){
              borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Conectado","Conectado")                  
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Desconectado","Desconectado")
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Comenzando","Comenzando")      
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Cargando","Cargando")      
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Parada","Parada")      
              añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"Completada","Completada")
            }
            else{
              document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "")              
            }

            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][0][idAtributo]

          }
        }
        else if(idCategoria.includes("MeteoData")){

          unidad = ""          

          if(idAtributo === "Humidity"){ unidad = "%" }
          else if(idAtributo === "PrecipRate"){ unidad = "L/m²" }
          else if(idAtributo === "SolarRadiation"){ unidad = "W/m²" }
          else if(idAtributo === "Temperature"){ unidad = "°C" }
          else if(idAtributo === "UV"){ unidad = "" }
          else if(idAtributo === "WindSpeed"){ unidad = "Km/h" }
          
          else if(idAtributo === "SunriseOffset"){ unidad = "Minutos" }
          else if(idAtributo === "SunsetOffset"){ unidad = "Minutos" }          

          document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", unidad)  
          document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
          document.getElementById("valorActualAtributo"+idCondicion).innerHTML = parseFloat(params.objDatosDashboard["MeteoData"][idAtributo]).toFixed(0)+" "+unidad
        }
        else if(idCategoria.includes("Schedule")){

          var d = new Date();          

          unidad = ""
          var valorActual = ""

          if(idAtributo === "Minute"){ 
            valorActual = d.getMinutes()
          }
          else if(idAtributo === "Hour"){ 
            valorActual = d.getHours()
          }
          else if(idAtributo === "Day"){ 
            valorActual = d.getDate()
          }
          else if(idAtributo === "WeekDay"){ 

            if(d.getDay() === 0){
              valorActual = dashboardCommonJS.obtenerNombreDiaDeLaSemana(7)
            }
            else{
              valorActual = dashboardCommonJS.obtenerNombreDiaDeLaSemana(d.getDay())
            }         
              
            borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))          

            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"1",dashboardCommonJS.obtenerNombreDiaDeLaSemana(1))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"2",dashboardCommonJS.obtenerNombreDiaDeLaSemana(2))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"3",dashboardCommonJS.obtenerNombreDiaDeLaSemana(3))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"4",dashboardCommonJS.obtenerNombreDiaDeLaSemana(4))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"5",dashboardCommonJS.obtenerNombreDiaDeLaSemana(5))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"6",dashboardCommonJS.obtenerNombreDiaDeLaSemana(6))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"7",dashboardCommonJS.obtenerNombreDiaDeLaSemana(7))                      

          }
          else if(idAtributo === "Month"){ 
            valorActual = dashboardCommonJS.obtenerNombreMes(d.getMonth()+1)
    
            borrarOpcionesCombo(document.getElementById("selectEstadoDispositivo"+idCondicion))          

            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"1",dashboardCommonJS.obtenerNombreMes(1))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"2",dashboardCommonJS.obtenerNombreMes(2))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"3",dashboardCommonJS.obtenerNombreMes(3))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"4",dashboardCommonJS.obtenerNombreMes(4))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"5",dashboardCommonJS.obtenerNombreMes(5))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"6",dashboardCommonJS.obtenerNombreMes(6))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"7",dashboardCommonJS.obtenerNombreMes(7))
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"8",dashboardCommonJS.obtenerNombreMes(8))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"9",dashboardCommonJS.obtenerNombreMes(9))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"10",dashboardCommonJS.obtenerNombreMes(10))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"11",dashboardCommonJS.obtenerNombreMes(11))    
            añadirOpcionACombo(document.getElementById("selectEstadoDispositivo"+idCondicion),"12",dashboardCommonJS.obtenerNombreMes(12))    

          }

          document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", unidad)  
          document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
          document.getElementById("valorActualAtributo"+idCondicion).innerHTML = valorActual + " " + unidad
        }
        else{//Proceso datos estructuralmente de forma genérica  
          
          if(params.objDatosDashboard[idCategoria][idAtributo].Unit !== undefined){

            unidad = params.objDatosDashboard[idCategoria][idAtributo].Unit
            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", unidad)  
            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            if(unidad === "€"){
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(params.objDatosDashboard[idCategoria][idAtributo].Value).toFixed(2))+" "+unidad
            }
            if(unidad === "W"){
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(params.objDatosDashboard[idCategoria][idAtributo].Value.replace(".","")).toFixed(0))+" "+unidad
            }
            else{              
              document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(params.objDatosDashboard[idCategoria][idAtributo].Value).toFixed(0))+" "+unidad
            }
            
          }

          else if( (idAtributo === "EnergyBuyPrice") || (idAtributo === "MarketAverageBuyPrice") || (idAtributo === "EnergySellPrice") || (idAtributo === "DailyEnergySellPrice") ){            
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(params.objDatosDashboard[idCategoria][idAtributo]).toFixed(3))+" €/kW"
            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "€/kW")  
          }

          else{
            document.getElementById("fieldsetValorAtributo"+idCondicion).setAttribute("data-label", "")  
            document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")
            document.getElementById("valorActualAtributo"+idCondicion).innerHTML = params.objDatosDashboard[idCategoria][idAtributo]
          }
        }
      }

      var selectComparadores = document.getElementById("selectListaComparadores"+params.conditionInfo.conditionId)

      // Seteo default para todos y luego modifico en casos específicos      
      document.getElementById("labelValorAtributo"+idCondicion).innerHTML = "Valor"
      document.getElementById("fieldsetListaComparadores"+idCondicion).className = document.getElementById("fieldsetListaComparadores"+idCondicion).className.replaceAll(" hidden", "")
      document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "")

      if( (document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value.includes("|Estado")) ||
          (idAtributo === "ChargeLatchStatus") ||
          (idAtributo === "ChargeStatus") ||
          (idAtributo === "FVStatus") ||
          (idAtributo === "BatteryStatus") || 
          (idAtributo === "ForceSurplusSellToGrid") || 
          (idAtributo === "ForceBatteryChargeFromGrid")
        ){

        document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "")
        document.getElementById("valorAtributo"+params.conditionInfo.conditionId).value = document.getElementById("selectEstadoDispositivo"+params.conditionInfo.conditionId).value

        //Ahora muestro las opciones de comparador para estados
        
        borrarOpcionesCombo(selectComparadores)

        var option = document.createElement("option");
        option.text = "Igual a";
        option.value = "=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Distinto de";
        option.value = "!=";      
        selectComparadores.appendChild(option);      

      }
      else if( (document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value === "WeekDay") ||
          (document.getElementById("selectListaAtributos"+params.conditionInfo.conditionId).value === "Month" )
        ){

        document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "")
        document.getElementById("valorAtributo"+params.conditionInfo.conditionId).value = document.getElementById("selectEstadoDispositivo"+params.conditionInfo.conditionId).value

        //Ahora muestro las opciones de comparador para estados
        
        borrarOpcionesCombo(selectComparadores)

        option = document.createElement("option");
        option.text = "Igual a";
        option.value = "=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Mayor o igual que";
        option.value = ">=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Menor o igual que";
        option.value = "<=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Mayor que";
        option.value = ">";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Menor que";
        option.value = "<";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Distinto de";
        option.value = "!=";      
        selectComparadores.appendChild(option);        

      }
      else if( (idAtributo === "ItsDay") || (idAtributo === "ItsNight") ){            

        document.getElementById("fieldsetListaComparadores"+idCondicion).className = document.getElementById("fieldsetListaComparadores"+idCondicion).className.replaceAll(" hidden", "") + " hidden"            
        document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className = document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"            

        document.getElementById("valorAtributo"+idCondicion).value = "0"

      }
      else if( (idAtributo === "SunriseOffset") || (idAtributo === "SunsetOffset") ){

        document.getElementById("fieldsetListaComparadores"+idCondicion).className = document.getElementById("fieldsetListaComparadores"+idCondicion).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className = document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className.replaceAll(" hidden", "")
        document.getElementById("divValorActualAtributo"+idCondicion).className = document.getElementById("divValorActualAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"            
        document.getElementById("labelValorAtributo"+idCondicion).innerHTML = "Y tras"

        document.getElementById("valorAtributo"+idCondicion).value = "0"

      }
      else if( (idAtributo === "EnergyBuyPrice") || (idAtributo === "MarketAverageBuyPrice") || (idAtributo === "EnergySellPrice") || (idAtributo === "DailyEnergySellPrice") ){

        borrarOpcionesCombo(selectComparadores)

        option = document.createElement("option");
        option.text = "Igual a";
        option.value = "=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Mayor o igual que";
        option.value = ">=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Menor o igual que";
        option.value = "<=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Mayor que";
        option.value = ">";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Menor que";
        option.value = "<";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Distinto de";
        option.value = "!=";      
        selectComparadores.appendChild(option);      

        // Y ahora las opciones especiales

        if( (idAtributo === "EnergyBuyPrice") || (idAtributo === "MarketAverageBuyPrice") ){

          option = document.createElement("option");
          option.value = "=···BestBuyPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = "=···WorstBuyPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = "<=···DailyAverageBuyPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = ">···DailyAverageBuyPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

        }
        else if( (idAtributo === "EnergySellPrice") || (idAtributo === "DailyEnergySellPrice") || (idAtributo === "DailyAverageSellPriceDaylight")){

          option = document.createElement("option");
          option.value = "=···BestSellPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = "=···WorstSellPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = "<=···DailyAverageSellPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = ">···DailyAverageSellPrice";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);   

          option = document.createElement("option");
          option.value = "<=···DailyAverageSellPriceDaylight";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option);

          option = document.createElement("option");
          option.value = ">···DailyAverageSellPriceDaylight";      
          option.text = initialConfigCommonJS.obtenerLiteralAtributo(option.value);          
          selectComparadores.appendChild(option); 

        }

        try{ //Lo vuelvo a setear ya que al reconstruir la combo se perdió el valor default
          document.getElementById("selectListaComparadores"+params.conditionInfo.conditionId).value = params.conditionInfo.comparator
        }
        catch(error){
          console.log(error)
        }

        gestionarVisibilidadValorCondicion(document.getElementById("selectListaComparadores"+idCondicion).value,idCondicion)

      }
      else{

        document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "")
        document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className = document.getElementById("fieldsetEstadoAtributo"+params.conditionInfo.conditionId).className.replaceAll(" hidden", "") + " hidden"

        //Ahora muestro las opciones de comparador para cualquier opción distinta a estado

        borrarOpcionesCombo(selectComparadores)

        option = document.createElement("option");
        option.text = "Igual a";
        option.value = "=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Mayor o igual que";
        option.value = ">=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Menor o igual que";
        option.value = "<=";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Mayor que";
        option.value = ">";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Menor que";
        option.value = "<";      
        selectComparadores.appendChild(option);

        option = document.createElement("option");
        option.text = "Distinto de";
        option.value = "!=";      
        selectComparadores.appendChild(option);      

      }
    }
    catch(error){ /* Controlo posibles errores en reglas cambiadas para que puedan modificarlas */}

  }

  function actualizarEstadoDispositivo(idSelect, idCampo){

    document.getElementById(idCampo).value = document.getElementById(idSelect).value

  }

  function selectorDinamicoElementoRegla(elemento){

    document.getElementById("searchElementosReglas").value = ""
    rulesCommonJS.filtrarElementosSeleccionReglas()

    var elementoTemp = document.getElementById(elemento)

    if(elementoTemp.length >= 1){ //Tengo demasiada información, abro el menu lateral de filtrado
      elementoTemp.blur()
      params.visibilidadModalFiltradoDatos("abrir")
      
      // Aquí generar listado de elementos
      var listadoElementos = {
        "categoria": document.getElementById(elemento.replace("Lista","Categoria")).value,
        "selectId": elemento,
        "valores": []
      }

      for(var x=0; x<elementoTemp.length; x++){       
        listadoElementos.valores.push({
          "valor": elementoTemp.options[x].value,
          "texto": elementoTemp.options[x].text
        })
      }

      params.setObjRuleElementSelector(listadoElementos)

    }

  }

  function gestionarVisibilidadValorCondicion(comparadorSeleccionado,idCondicion){

    if(document.getElementById("selectCategoriaAtributos"+idCondicion).value === "SelfConsumptionAndSavingsData" ){
      if( (comparadorSeleccionado === "=···BestBuyPrice") || (comparadorSeleccionado === "=···WorstBuyPrice") || (comparadorSeleccionado === "<=···DailyAverageBuyPrice") || (comparadorSeleccionado === ">···DailyAverageBuyPrice")
        || (comparadorSeleccionado === "=···BestSellPrice") || (comparadorSeleccionado === "=···WorstSellPrice") || (comparadorSeleccionado === "<=···DailyAverageSellPrice") || (comparadorSeleccionado === ">···DailyAverageSellPrice") 
        || (comparadorSeleccionado === "<=···DailyAverageSellPriceDaylight") || (comparadorSeleccionado === ">···DailyAverageSellPriceDaylight")){

        //Oculto combo estado y valor y lo seteo a 0 ya que tomaré el segundo valor dinámico del comparado
        document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className = document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("fieldsetEstadoAtributo"+idCondicion).className = document.getElementById("fieldsetEstadoAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("valorAtributo"+idCondicion).value = "0"

      }
      else{
        //Oculto combo estado, muestro valor y lo inicializo a ""
        document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className = document.getElementById("fieldsetPrincipalValorAtributo"+idCondicion).className.replaceAll(" hidden", "")
        document.getElementById("fieldsetEstadoAtributo"+idCondicion).className = document.getElementById("fieldsetEstadoAtributo"+idCondicion).className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("valorAtributo"+idCondicion).value = ""
      }
    }

  }

  return (    
    
    <>
                              
      <fieldset className="radio multiple center" id={"selectOperadorCondicional"+params.conditionInfo.conditionId}>
        <div className="tabs size-s conditional">
          <input type="radio" id={"selectOperadorCondicional"+params.conditionInfo.conditionId+"&"} name={"selectOperadorCondicional"+params.conditionInfo.conditionId} defaultChecked/>
          <label htmlFor={"selectOperadorCondicional"+params.conditionInfo.conditionId+"&"}><span className="label uppercase">y</span></label>
          <input type="radio" id={"selectOperadorCondicional"+params.conditionInfo.conditionId+"|"} name={"selectOperadorCondicional"+params.conditionInfo.conditionId}/>
          <label htmlFor={"selectOperadorCondicional"+params.conditionInfo.conditionId+"|"}><span className="label uppercase">o</span></label>
        </div>
      </fieldset>
      
      <section id={"detalleCondicion"+params.conditionInfo.conditionId} className="bubble rule expanded"> 

        <button className="link expandable" onClick={ () => params.mostrarOcultarBloqueResumen("detalleCondicion"+params.conditionInfo.conditionId)}>
          <span className="material-icon fold show-expanded">unfold_more</span>
          <span className="material-icon fold show-collapsed">unfold_less</span>
        </button>
      
        <fieldset className="detail">
          
          <fieldset className="dropdown">
            <label htmlFor={"labelCategoriaAtributos"+params.conditionInfo.conditionId}>Categorías</label>            
            <div className="icon-wrapper">
              <select id={"selectCategoriaAtributos"+params.conditionInfo.conditionId} onChange={() => cargarAtributosCategoria(document.getElementById("selectCategoriaAtributos"+params.conditionInfo.conditionId).value)}/>                             
            </div>
          </fieldset>

          <fieldset className="two-columns gap-06">

            <fieldset className="dropdown" onClick={() => selectorDinamicoElementoRegla("selectListaAtributos"+params.conditionInfo.conditionId)}>
              <label htmlFor={"labelListaAtributos"+params.conditionInfo.conditionId}>Dato</label>
              <div className="icon-wrapper">
                <select id={"selectListaAtributos"+params.conditionInfo.conditionId} onChange={() => setearUnidadAtributo(params.conditionInfo.conditionId)}/>
              </div>
            </fieldset>

            <fieldset id={"fieldsetListaComparadores"+params.conditionInfo.conditionId} className="dropdown">
              <label htmlFor={"labelListaComparadores"+params.conditionInfo.conditionId}>Es</label>
              <div className="icon-wrapper">
                <select id={"selectListaComparadores"+params.conditionInfo.conditionId} onChange={() => gestionarVisibilidadValorCondicion(document.getElementById("selectListaComparadores"+params.conditionInfo.conditionId).value,params.conditionInfo.conditionId)}>
                  <option value="=">Igual a</option>
                  <option value=">=">Mayor o igual que</option>
                  <option value="<=">Menor o igual que</option>
                  <option value=">">Mayor que</option>
                  <option value="<">Menor que</option>                  
                  <option value="!=">Distinto de</option>
                </select>
              </div>
            </fieldset>

            <fieldset id={"fieldsetEstadoAtributo"+params.conditionInfo.conditionId} className="dropdown hidden">
              <label htmlFor={"labelSelectEstadoDispositivo"+params.conditionInfo.conditionId}>Estado</label>
              <div className="icon-wrapper">
                <select id={"selectEstadoDispositivo"+params.conditionInfo.conditionId} onChange={() => actualizarEstadoDispositivo("selectEstadoDispositivo"+params.conditionInfo.conditionId, "valorAtributo"+params.conditionInfo.conditionId)} onBlur={() => params.mostrarOcultarBloqueResumen("detalleCondicion"+params.conditionInfo.conditionId)}>
                               
                </select>
              </div>
            </fieldset>

            <fieldset id={"fieldsetPrincipalValorAtributo"+params.conditionInfo.conditionId} className="text">
              <label id={"labelValorAtributo"+params.conditionInfo.conditionId} htmlFor={"valorAtributo"+params.conditionInfo.conditionId}>Valor</label>
              <fieldset id={"fieldsetValorAtributo"+params.conditionInfo.conditionId} className="icon-wrapper data" data-label="">
                <input type="text" id={"valorAtributo"+params.conditionInfo.conditionId} onBlur={() => params.mostrarOcultarBloqueResumen("detalleCondicion"+params.conditionInfo.conditionId)}/>
              </fieldset>
            </fieldset>

          </fieldset>

          <div id={"divValorActualAtributo"+params.conditionInfo.conditionId} className="message info left hidden">            
            <div className="horizontal vertical-center">
              <span className="material-icon">info</span>
              <p>Valor actual del atributo: <span className="" style={{color: "#fff"}} id={"valorActualAtributo"+params.conditionInfo.conditionId}></span></p>              
            </div>                
          </div>

          <div className="actions">

            { params.conditionInfo.conditionId !== "1" ?
            <button id={"botonEliminar"+params.conditionInfo.conditionId}className="link delete" type="button" onClick={ () => params.eliminarCondicion(params.conditionInfo.conditionId)}><span className="material-icon">remove_circle</span>Eliminar</button>
            : <></>
            }
            
          </div>

        </fieldset>
      
        <div className="summary horizontal gap-03 vertical-center">
          <figure id={"figureIconoCondicionRegla"+params.conditionInfo.conditionId} className="avatar size-m orange"><span id={"spanIconoCondicionRegla"+params.conditionInfo.conditionId} className="material-icon">solar_power</span></figure>
          <h1 id={"resumenReglaCondicion"+params.conditionInfo.conditionId}> </h1>
        </div>
    </section>
    </>
  )
}

export default Condition